export default function GS_Format_Clear() {
  return (
    <div className="p-4">
      <h1>GS Format Clear</h1>
    </div>
  );
}
